export class MiraApiError extends Error {
    status;
    code;
    constructor(message, status, code) {
        super(message);
        this.name = 'MiraApiError';
        this.status = status;
        this.code = code;
    }
}
export function normalizeApiError(error) {
    if (error instanceof MiraApiError)
        return error;
    if (error instanceof Error)
        return new MiraApiError(error.message, 0);
    return new MiraApiError('Something went wrong. Please try again.', 0);
}
export async function errorFromResponse(response, fallback = 'Request failed') {
    const text = await response.text();
    let message = fallback;
    let code;
    if (text) {
        try {
            const body = JSON.parse(text);
            message = body.message || body.error || fallback;
            code = body.code;
        }
        catch {
            message = fallback;
        }
    }
    return new MiraApiError(message, response.status, code);
}
